import styled from 'styled-components/macro';

export const LoaderWrapper = styled.div`
  position: relative;
`;

export const Loader = styled.div`
  position: absolute;
  top: calc(50% - 10px);
  left: -25px;

  display: inline-block;

  width: 20px;
  height: 20px;
`;

export const LoaderParts = styled.div`
  position: absolute;

  display: block;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  margin: 2px;
  border: 2px solid #fff;
  border-color: #fff transparent transparent transparent;
  border-radius: 50%;

  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  :nth-child(1) {
    animation-delay: -0.45s;
  }
  :nth-child(2) {
    animation-delay: -0.3s;
  }
  :nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
